import { render } from "./DashboardNav.vue?vue&type=template&id=57cf7b7d&scoped=true"
import script from "./DashboardNav.vue?vue&type=script&lang=js"
export * from "./DashboardNav.vue?vue&type=script&lang=js"

import "./DashboardNav.vue?vue&type=style&index=0&id=57cf7b7d&scoped=true&lang=css"

import exportComponent from "D:\\Xoan\\asp-user\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57cf7b7d"]])

export default __exports__